/** Business e-filing invoices come from Documents → Business → Office, not client invoices. */

function isOfficePurposeDocument(doc) {
  if (!doc || doc.type === "folder") return false;
  const docType = String(doc?.doc_type ?? doc?.docType ?? "")
    .trim()
    .toLowerCase();
  const folderType = String(doc?.folder_type ?? doc?.folderType ?? "")
    .trim()
    .toLowerCase();
  if (docType === "office") return true;
  if (!docType && folderType === "office") return true;
  return false;
}

export function getOfficeDocumentId(doc) {
  const id = doc?.document_id ?? doc?.documentId ?? doc?.id;
  return id == null || id === "" ? "" : String(id);
}

export function getOfficeDocumentName(doc) {
  return String(doc?.document_name ?? doc?.documentName ?? "").trim();
}

export function getOfficeDocumentLink(doc) {
  return String(
    doc?.document_link ?? doc?.documentLink ?? doc?.s3_url ?? doc?.s3Url ?? "",
  ).trim();
}

export function listBusinessOfficeDocuments(allDocuments = []) {
  const list = Array.isArray(allDocuments) ? allDocuments : [];
  return list.filter(isOfficePurposeDocument);
}

export function findBusinessOfficeDocument(documents, key) {
  const target = String(key ?? "").trim();
  if (!target) return null;
  const list = listBusinessOfficeDocuments(documents);
  return (
    list.find((doc) => getOfficeDocumentId(doc) === target) ||
    list.find((doc) => getOfficeDocumentName(doc) === target) ||
    list.find((doc) => getOfficeDocumentLink(doc) === target) ||
    null
  );
}

export function buildBusinessOfficeInvoiceDropdown(
  documents = [],
  currentInvoiceNo = "",
) {
  const opts = [{ id: "", value: "Select invoice", keepAtTop: true }];
  const seen = new Set();
  listBusinessOfficeDocuments(documents).forEach((doc) => {
    const name = getOfficeDocumentName(doc);
    const id = name || getOfficeDocumentId(doc) || getOfficeDocumentLink(doc);
    if (!id || seen.has(id)) return;
    seen.add(id);
    const folder = String(
      doc.folder_name ?? doc.folderName ?? doc.__folderPath ?? "",
    ).trim();
    const suffix =
      folder && folder.toLowerCase() !== "home" ? ` (${folder})` : "";
    opts.push({
      id,
      value: `${name || "Document"}${suffix}`,
    });
  });
  const current = String(currentInvoiceNo || "").trim();
  if (current && !opts.some((opt) => String(opt.id) === current)) {
    opts.push({ id: current, value: current });
  }
  return opts;
}
